import '../../../../../../../Avency.Nwd.Shop/Resources/Private/Assets/JavaScripts/Project/globals';

/**
 * Article content tabs
 *
 * Fix the offset of the wrapper to match the height of the navigation
 */
(function(PageLoadedQueue) {
    const articleWrapper = document.querySelector('.article-content-tabs-wrapper');

    if (articleWrapper) {
        async function setTopOffsetForWrapper() {
            const headerNavigation = document.querySelector('#header-navigation');

            let promise = new Promise((res, rej) => {
                setTimeout(() => res(headerNavigation.clientHeight), 500);
            });

            let navigationHeight = await promise;

            document.documentElement.style.setProperty('--plandent-navigation-height', navigationHeight + 'px');
        };

        window.addEventListener('resize', setTopOffsetForWrapper, {passive: true});
        window.addEventListener('scroll', setTopOffsetForWrapper, {passive: true});

        window.PageLoadedQueue.addFunction(function () {
            setTopOffsetForWrapper();
        });
    }
})(window.PageLoadedQueue);
